var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 10,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.322 14.2961C24.9142 14.4555 25.3811 14.9224 25.5405 15.5146C25.8366 16.5965 25.8252 18.8514 25.8252 18.8514C25.8252 18.8514 25.8252 21.0948 25.5405 22.1767C25.3811 22.7689 24.9142 23.2358 24.322 23.3952C23.2401 23.68 18.9126 23.68 18.9126 23.68C18.9126 23.68 14.5965 23.68 13.5032 23.3839C12.9111 23.2244 12.4441 22.7575 12.2847 22.1653C12 21.0948 12 18.84 12 18.84C12 18.84 12 16.5965 12.2847 15.5146C12.4441 14.9224 12.9224 14.4441 13.5032 14.2847C14.5851 14 18.9126 14 18.9126 14C18.9126 14 23.2401 14 24.322 14.2961ZM21.1333 18.8398L17.5347 20.9125V16.7672L21.1333 18.8398Z",
    fill: "#023047"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d1dc1bd41855a2e37ab9e026420124d0.svg";
export { ForwardRef as ReactComponent };